import { useAuthContext } from './agencyAuthHook'
import { getAllParties } from '../redux/reducers/partiesSlice'
import { useDispatch } from 'react-redux';

export default function PartiesHook() {
    const dispatch = useDispatch()
    const apiUrl = process.env.REACT_APP_API_URL;
    const { agency } = useAuthContext()
    const getParties=async()=>{
       try {
        const response=await fetch(`${apiUrl}/api/agencies/parties/get`,{
          headers:{
            'Authorization': `Bearer ${agency.token}`
            
          }
        })
        
        const json=await response.json()
        if(response.ok){
          
          dispatch(getAllParties(json.data))
        }
        
       } catch (error) {
       console.log('error',error)
       }
    }
  return {getParties}
}
